__turbopack_context__.v({
  "bentoWrapper": "style-module-scss-module__CMm0oG__bentoWrapper",
});
